import * as firebase from 'firebase';

const config = {
  apiKey: "AIzaSyDAyInpSHimA2f-jbb2S2p26P-YwjaHW-s",
  authDomain: "te-matuku-tech.firebaseapp.com",
  databaseURL: "https://te-matuku-tech.firebaseio.com",
  projectId: "te-matuku-tech",
  storageBucket: "te-matuku-tech.appspot.com"
};
firebase.initializeApp(config);

export default firebase;